import { api, ApiRes } from './_api-client';

export enum StoryBoardTracks {
  storyBoard = 'storyBoard',
  clipBoard = 'clipBoard',
  discardBoard = 'discardBoard',
}

export type StoryBoard = { -readonly [key in keyof typeof StoryBoardTracks]: CellClip[] };
export type StoryboardPayload = { storyId: number } & Partial<StoryBoard>;
export type StoryboardRes = { storyId: number } & StoryBoard;

// S E R V I C E

export const getStoryboard = (storyId: StoryId) => {
  return api.get<StoryboardRes>(`/StoryBoard/GetBoardsMap?storyId=${storyId}`);
};

export const setStoryboard = (body: StoryboardPayload) => {
  return api.patch<ApiRes>(`/StoryBoard/SetBoardsMap`, body);
};
